module.exports = "<p>\n  incrementdetails-grid works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/incrementdetails/incrementdetails-grid/incrementdetails-grid.component.html
// module id = ./src/app/hrms/serviceregister/incrementdetails/incrementdetails-grid/incrementdetails-grid.component.html
// module chunks = main